import { FunctionComponent } from "react";
import { Typography, Paper, Tooltip } from './../../tailwindcomponents';
import { EmpInGroup } from '../../types/accessControl';

type ShowGroupsProps = {
    groups: EmpInGroup[] | undefined,
    groupType: string
}

const ShowGroups: FunctionComponent<ShowGroupsProps> = ({ groups, groupType }) => {
    return (
        <div>
            <Typography alignSelf="center" align="center" fontWeight="normal" margin={[0, 0, 0, 0]} text={`${groupType === "Access" ? "Access groups" : groupType === "User" ? "User groups" : ""}`} />
            {groups !== undefined &&
                groups.map(item => {
                    return (
                        <div className="w-1/3 mx-auto">
                            <Tooltip title={item.group_permission_text} type='primary' placement="top-start">
                                <Paper elevation={3} >
                                    <div className="mt-2 h-[25px]">
                                        <Typography alignSelf="center" align="center" padding={[0, 0, 0, 0]} fontWeight="bold" text={item.group_name} />
                                    </div>
                                </Paper>
                            </Tooltip>
                        </div>
                    )
                })
            }
        </div>
    )
}
export default ShowGroups;